// @flow
import {
  WAG_TAG_PAGE_MOUNTED,
  WAG_TAG_FORM_SUBMITTED,
  WAG_TAG_CTA_CLICKED,
  type TrackingEvent,
} from '../TrackingEventTypes.constants';

import {
  FUNNEL_WAG_TAG,
  type TrackingFunnel,
} from '../TrackingFunnels.constants';

import {
  EVENT_NAME_PAGE_LOADED,
  EVENT_NAME_CTA_CLICKED,
  EVENT_NAME_ORDER_FORM_SUBMITTED,
  type TrackingEventName,
} from '../TrackingEventNames.constants';

import {
  STEP_PAGE_LOADED,
  STEP_CTA_CLICKED,
  STEP_FORM_SUBMITTED,
  type TrackingStep,
} from '../TrackingSteps.constants';

import {
  LOCATION_HERO_CTA,
  type TrackingLocation,
} from '../TrackingLocations.constants';

type TrackingConfig = {
  eventName: TrackingEventName,
  funnel: TrackingFunnel,
  location?: TrackingLocation,
  step: TrackingStep,
};

export const eventProperties: {
  [TrackingEvent]: TrackingConfig
} = {
  [WAG_TAG_PAGE_MOUNTED]: {
    eventName: EVENT_NAME_PAGE_LOADED,
    funnel: FUNNEL_WAG_TAG,
    step: STEP_PAGE_LOADED,
  },
  [WAG_TAG_FORM_SUBMITTED]: {
    eventName: EVENT_NAME_ORDER_FORM_SUBMITTED,
    funnel: FUNNEL_WAG_TAG,
    step: STEP_FORM_SUBMITTED,
  },
  [WAG_TAG_FORM_SUBMITTED]: {
    eventName: EVENT_NAME_ORDER_FORM_SUBMITTED,
    funnel: FUNNEL_WAG_TAG,
    step: STEP_FORM_SUBMITTED,
  },
  [WAG_TAG_CTA_CLICKED]: {
    eventName: EVENT_NAME_CTA_CLICKED,
    funnel: FUNNEL_WAG_TAG,
    step: STEP_CTA_CLICKED,
    location: LOCATION_HERO_CTA,
  },
};


export default eventProperties;
